/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { ChatManagementSaveMessageResponse } from './ChatManagementSaveMessageResponse';

export type ChatManagementSaveMessageResponseApiRespoonse = {
    data?: ChatManagementSaveMessageResponse;
    status?: ChatManagementSaveMessageResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace ChatManagementSaveMessageResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

